import type { RootState } from '..';
import { PrintState } from './print.reducer';

export const getPrintedTicketsMap = (state: RootState): PrintState['printedTicketsMap'] =>
    state.print.printedTicketsMap;
